<template>
    <div class="h-[60px] w-full flex items-center justify-between z-50 shadow-app-header bg-white">
        <div class="nav-header-shadow h-full w-full pr-6 flex items-center justify-end">
            <div class="flex items-center gap-4 header">
                <InterviewAiOnboardingTrigger
                    v-if="['interview-ai', 'interview-ai-interview'].includes(route.name)"
                />
							
                <div
                    @click="handleDashboardOnboarding"
                    v-tooltip="{
                        content: 'About AutoApplyAI',
                        placement: 'bottom',
                        popperClass: 'max-w-[221px] !text-center !text-[12px] !leading-[16px] font-[Roboto] px-2 py-1'
                    }"
                    v-if="$route.name === 'auto-apply'"
                >
                    <auto-apply-tooltip/>
                </div>
							
                <activities-dropdown v-if="isAuthenticated()"/>
            </div>
        </div>
    </div>
</template>

<script setup>
import { setAuthState } from '../composables/auth'
import { useRoute } from 'vue-router';

import InterviewAiOnboardingTrigger from "./interview-ai/interview-ai-onboarding-trigger.vue"
import ActivitiesDropdown from './activities-dropdown'
import AutoApplyTooltip from "../icons/auto-apply-tooltip.vue";

import { useAutoApplyJobsStore } from "../store/auto-apply.store";

const { isAuthenticated } = setAuthState()
const route = useRoute()

const emit = defineEmits(['dashboard-onboarding'])

const handleDashboardOnboarding = () => {
    const autoApplyStore = useAutoApplyJobsStore();
    autoApplyStore.setDashboardOnboarding(true);
}
</script>

